
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from "react";
import Page from "@/src/components/Page";
import SearchCveShell from "@/src/layouts/SearchCveShell";

const SearchCvePage = ({ q,page }) => (
    <Page name="Recherche CVE" path="/search-cve/">
        <SearchCveShell q={q} defaultPage={page} />
    </Page>
);

 async function _getServerSideProps(context) {
    const { query } = context;
    const q = query.q || ""; 
    const page = query.page ? parseInt(query.page):1; 
    return {
        props: {
            q,page
        },
    };
}

export default SearchCvePage;


    export async function getServerSideProps(ctx) {
        let res = _getServerSideProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/search-cve',
              loaderName: 'getServerSideProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  